import { render, staticRenderFns } from "./SkeletonNotification.vue?vue&type=template&id=8a37e616"
import script from "./SkeletonNotification.vue?vue&type=script&lang=js"
export * from "./SkeletonNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports